import { getAPIFromDomain } from "../lib/api";
import { Facility } from "./common/facility";

export type InventoryTransfer = {
  id: string;
  status: "requested" | "processing" | "completed" | "cancelled";
  from_facility: Facility["name"];
  to_facility: Facility["name"];
  order_id?: string;
  created_at?: string;
  items: InventoryTransferItem[];
  activities: InventoryTransferActivity[];
};

export type InventoryTransferItem = {
  product: { id: string; name: string; sku: string };
  requested: number;
  sent: number;
  received: number;
};

export type InventoryTransferActivity = {
  id: string;
  type: "inbound" | "outbound";
  name: string;
  created_at: string;
};

export async function fetchInventoryTransfers(query: {
  q?: string;
  page?: number;
  per_page?: number;
  organization_id?: string;
}): Promise<{ data: InventoryTransfer[]; meta: { current_page: number; total_entries: number } }> {
  const api = getAPIFromDomain("fulfillment");
  const res = await api.get(`/inventory_transfer_orders`, {
    params: query,
  });
  return res.data;
}

export async function fetchInventoryTransfer(id: string): Promise<InventoryTransfer> {
  const api = getAPIFromDomain("fulfillment");
  const res = await api.get(`/inventory_transfer_orders/${id}`);
  return res.data;
}

type CreateInventoryTransferPayload = {
  organization_id: string;
  from_facility: string;
  to_facility: string;
  items: {
    product_id: string;
    quantity: number;
  }[];
};

export async function createInventoryTransfer(payload: CreateInventoryTransferPayload) {
  const api = getAPIFromDomain("fulfillment");
  const res = await api.post(`/inventory_transfer_orders`, payload);
  return res.data;
}

export async function cancelInventoryTransfer(id: string) {
  const api = getAPIFromDomain("fulfillment");
  const res = await api.put(`/inventory_transfer_orders/${id}/cancel`);
  return res.data;
}
